import type { FunctionEndNodeProps } from "./FunctionEndNode";
import { PortHandle } from "../PortHandle";
import dico from "../../../../util/src/language/dico";
import { BehaviorNodeCard } from "../BehaviorNodeCard.js";

export function ObjectEndNode({
  node,
  setPortsMap,
  onPortMouseDown,
  onPortMouseUp,
  isPortConnected,
}: FunctionEndNodeProps) {
  const port = node.ports.find((p) => p.id === "value");
  return (
    <BehaviorNodeCard
      minWidth={220}
      header={dico().behavior.sceneCatalog.objectEditor.end}
      headerBackground="linear-gradient(180deg, #6ee7b7 0%, #059669 55%, #047857 100%)"
    >
      {port && (
        <div
          style={{ padding: "8px 12px" }}
          onMouseDown={(event) => event.stopPropagation()}
        >
          <PortHandle
            node={node}
            port={port}
            setPortsMap={setPortsMap}
            onMouseDown={() => onPortMouseDown?.(node.id, port)}
            onMouseUp={() => onPortMouseUp?.(node.id, port)}
            isConnected={isPortConnected?.(node.id, port.id) ?? false}
          />
        </div>
      )}
    </BehaviorNodeCard>
  );
}
